module.exports = __webpack_public_path__ + "img/payment-logos-envisionit.9398f33f.png";